import { RequestService } from "../../../../common/services/RequestService";
import { EDIT_PERSON } from "./constants";
import { adjustDataToFetch } from "./adjustData";

export const editPersonRequest = async (
  orderId,
  personId,
  personTypeKey,
  payload
) => {
  const response = await RequestService.put(
    EDIT_PERSON.replace("{order_id}", orderId).replace("{person_id}", personId),
    adjustDataToFetch(payload)
  );
  return response;
};
